import React from "react"
import ReactDOM from "react-dom"
import { WishList } from "./Components/WishList"

const rootEl = document.getElementById("wishListRoot")

rootEl && ReactDOM.render(
    <WishList />
    , rootEl
)